import React from "react";
import { Heart } from "lucide-react";

const Footer = () => {
  return (
    <footer className="bg-pink-950 text-pink-100/80 py-10">
      <div className="max-w-6xl mx-auto px-4 text-center space-y-2 text-sm">
        <div className="flex items-center justify-center gap-2 font-semibold text-pink-100">
          Feito com <Heart className="w-4 h-4 fill-pink-300 text-pink-300" /> para artesãs
        </div>
        <p>Todos os direitos reservados © 2026 – Acervo da Artesã.</p>
        <p className="text-xs text-pink-100/60 max-w-2xl mx-auto">
          Este site não é afiliado ao Facebook™ ou a qualquer entidade do Facebook™. Este produto é 100% digital e você recebe imediatamente após a confirmação do pagamento.
        </p>
      </div>
    </footer>
  );
};

export default Footer;
